import { render, staticRenderFns } from "./BlockEditor.vue?vue&type=template&id=2992663e&"
import script from "./BlockEditor.vue?vue&type=script&lang=ts&"
export * from "./BlockEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports